import { render } from "./AddPoint.vue?vue&type=template&id=6268ab58&scoped=true"
import script from "./AddPoint.vue?vue&type=script&lang=js"
export * from "./AddPoint.vue?vue&type=script&lang=js"

import "./AddPoint.vue?vue&type=style&index=0&id=6268ab58&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6268ab58"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QBanner,QBtn,QPopupProxy,QCard,QCardSection,QTooltip,QIcon,QFile,QList,QItem,QItemSection,QSpace,QInput,QLinearProgress,QDialog,QToggle,QMenu});
